import React from 'react';
import { PencilIcon, TrashIcon, DocumentTextIcon } from '@heroicons/react/24/outline';

const CATEGORY_LABELS = {
    common: 'Common',
    salaried: 'Salaried',
    selfEmployed: 'Self-Employed',
    nri: 'NRI',
    property: 'Property'
};

const CATEGORY_COLORS = {
    common: 'bg-blue-100 text-blue-700',
    salaried: 'bg-green-100 text-green-700',
    selfEmployed: 'bg-purple-100 text-purple-700',
    nri: 'bg-orange-100 text-orange-700',
    property: 'bg-pink-100 text-pink-700'
};

const DocumentCard = ({ document, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            <div className="p-5">
                <div className="flex items-start justify-between mb-4">
                    <div className="p-3 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 text-white shadow-sm">
                        <DocumentTextIcon className="h-6 w-6" />
                    </div>
                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(document)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(document.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-2">
                    <div className="flex items-center justify-between gap-2">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${CATEGORY_COLORS[document.category] || 'bg-gray-100 text-gray-600'}`}>
                            {CATEGORY_LABELS[document.category] || document.category}
                        </span>
                        <div className="flex items-center gap-2">
                            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${document.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                                {document.is_active ? 'Active' : 'Inactive'}
                            </span>
                            <span className="text-[10px] font-bold text-slate-400">#{document.display_order}</span>
                        </div>
                    </div>
                    <p className="text-slate-700 font-medium leading-relaxed">
                        {document.document_name}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DocumentCard;
